export type AppThemeName = 'light' | 'dark';

export interface IThemeOption {
  name: AppThemeName;
  label: string;
  swatch: string;
}

export const THEME_OPTIONS: IThemeOption[] = [
  { name: 'light', label: 'Claro', swatch: '#F3F6FA' },
  { name: 'dark', label: 'Escuro', swatch: '#062D3A' },
];

// Cor dos ícones/avatar/checkbox na tela de login.
export const LOGIN_ACCENT: Record<AppThemeName, string> = {
  light: '#0B7C86',
  dark: '#42F2F7',
};

// Cor do botão "Entrar" na tela de login.
export const LOGIN_BUTTON_ACCENT: Record<AppThemeName, { bg: string; hover: string }> = {
  light: { bg: '#42F2F7', hover: '#1FDDE3' },
  dark: { bg: '#42F2F7', hover: '#1FDDE3' },
};
